import { useState, useCallback } from 'react';
import { fetchAiInterpretation, AiFiltersRawResponse } from '../services/aiSearchService';

export const useAiSearch = () => {
  const [isAiSearching, setIsAiSearching] = useState(false);
  const [aiSearchError, setAiSearchError] = useState<string | null>(null);
  const [rawAiResponse, setRawAiResponse] = useState<AiFiltersRawResponse | null>(null);
  const [isAiConfirmationOpen, setIsAiConfirmationOpen] = useState(false);
  const [originalQuery, setOriginalQuery] = useState('');

  const executeAiSearch = useCallback(async (query: string) => {
    const trimmed = query.trim();
    if (!trimmed) return;

    setIsAiSearching(true);
    setAiSearchError(null);
    setOriginalQuery(trimmed); // Guardamos la frase original para el modal

    try {
      const filters = await fetchAiInterpretation(trimmed);
      setRawAiResponse(filters);
      setIsAiConfirmationOpen(true);
    } catch (err) {
      console.error("AI Search Hook Error:", err);
      setAiSearchError("No pude interpretar tu búsqueda. Inténtalo de nuevo con otros términos.");
    } finally {
      setIsAiSearching(false);
    }
  }, []);

  const closeAiConfirmation = () => {
    setIsAiConfirmationOpen(false);
  };

  return {
    isAiSearching,
    aiSearchError,
    rawAiResponse,
    isAiConfirmationOpen,
    executeAiSearch,
    closeAiConfirmation,
    originalQuery
  };
};